module.exports = __webpack_public_path__ + "img/Hos_xiehe.f40d82db.png";